import Component from "vue-class-component";
import Vue from "Vue";

@Component
export default class SkeletonLarge extends Vue {
}



// WEBPACK FOOTER //
// ./src/shared/components/Skeleton/SkeletonLarge/SkeletonLarge.ts